











































import { apiClient } from "@/services/api-client";
import LoadingBlock from "../LoadingBlock.vue";
import DocumentDownloader from "@/components/DocumentDownloader.vue";

export default {
  name: "DetailsDocuments",
  components: { DocumentDownloader, LoadingBlock },
  data() {
    return {
      documents: [],
      isLoading: false
    };
  },
  created() {
    this.isLoading = true;
    apiClient
      .getMaterieelDetailsDocs({
        materieelSoort: this.$route.params.id
      })
      .then(x => {
        this.documents = x.documents;
        this.isLoading = false;
      })
      .catch(err => {
        if (err.status === 400) {
          return;
        }

        return err;
      });
  },
  methods: {
    getFileIcon(extension) {
      switch (extension) {
        case ".pdf":
          return "file-pdf";
        case ".doc":
        case ".docx":
          return "file-word";
        case ".csv":
        case ".xls":
        case ".xlsx":
          return "file-excel";
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
        case ".bmp":
          return "file-image";
        default:
          return "file";
      }
    },
    getFileTitle(extension) {
      switch (extension) {
        case ".pdf":
          return "Pdf";
        case ".doc":
        case ".docx":
          return "Word";
        case ".csv":
        case ".xls":
        case ".xlsx":
          return "Excel";
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
        case ".bmp":
          return "Image";
        default:
          return "Bestand";
      }
    }
  }
};
